<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="结算申请编号" prop="dealCode">
          <el-input v-model="dataForm.dealCode" placeholder="结算申请编号"></el-input>
      </el-form-item>
          <el-form-item label="结算主体名称" prop="dealBody">
          <el-input v-model="dataForm.dealBody" placeholder="结算主体名称"></el-input>
      </el-form-item>
          <el-form-item label="统一社会信用编码" prop="taxCode">
          <el-input v-model="dataForm.taxCode" placeholder="统一社会信用编码"></el-input>
      </el-form-item>
          <el-form-item label="结算费用" prop="money">
          <el-input v-model="dataForm.money" placeholder="结算费用"></el-input>
      </el-form-item>
          <el-form-item label="结算状态" prop="status">
          <el-input v-model="dataForm.status" placeholder="结算状态"></el-input>
      </el-form-item>
          <el-form-item label="结算日期" prop="dealDate">
          <el-input v-model="dataForm.dealDate" placeholder="结算日期"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="creator">
          <el-input v-model="dataForm.creator" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createDate">
          <el-input v-model="dataForm.createDate" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updater">
          <el-input v-model="dataForm.updater" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateDate">
          <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="发票项目" prop="ticketPro">
          <el-input v-model="dataForm.ticketPro" placeholder="发票项目"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        dealCode: '',
        dealBody: '',
        taxCode: '',
        money: '',
        status: '',
        dealDate: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: '',
        ticketPro: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        dealCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dealBody: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dealType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dealDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creator: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        ticketPro: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/plat/deal/approval/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/plat/deal/approval/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
